import useAuth from "./useAuth";
import axios from "../api/axios";

const useLogout = () => {
  const { setAuth, setShowNotify, navigate } = useAuth();

  const logout = async () => {
    try {
      localStorage.removeItem("logo");
      localStorage.removeItem("mockLp");
      localStorage.removeItem("favicon");
      localStorage.removeItem("batchid");
      localStorage.removeItem("tokenKey");
      localStorage.removeItem("batchType");
      localStorage.removeItem("hideBatch");
      localStorage.removeItem("batchType");
      localStorage.removeItem("batchname");
      localStorage.removeItem("companyId");
      navigate("/");
      setAuth({});
      setShowNotify({ show: false });
      await axios.post(
        "node/auth/logout",
        { refreshToken: localStorage.getItem("refreshToken") },
        {
          headers: {
            Authorization: "abdjcdifouvn",
            "Content-Type": "application/json",
          },
        },
      );
    } catch (err) {
      console.error("useLogout err", err);
    } finally {
      localStorage.removeItem("refreshToken");
      try {
        if (window?.electronAPI?.googleOAuthLogOut) {
          window.electronAPI.googleOAuthLogOut();
        } else {
          console.log("googleOAuthLogOut not available -- skipping.");
        }
      } catch (err) {
        console.error("Error calling googleOAuthLogOut : ", err);
      }
    }
  };

  return logout;
};

export default useLogout;
